<template>
    <!-- Loading Skeleton -->
    <div v-if="isLoading">
        <h5 class="mt-6 px-8 mb-4 font-medium type-tertiary text-sm">{{ $t("Recently viewed") }}</h5>
        <ul class="pb-8 px-8 w-full overflow-x-auto flex gap-2 first-of-type:-pl-2">
            <li class="shrink-0 w-[167px]" v-for="n in 5" :key="n">
                <div class="bg-v2-gray-130 flex flex-col p-4 rounded h-full dark:bg-v2-gray-50">
                    <!-- Product Image Skeleton -->
                    <div class="flex justify-center flex-col h-20 mb-1">
                        <div class="loading-value h-16 w-16 mx-auto rounded"></div>
                    </div>
                    <!-- Product SKU Skeleton -->
                    <div class="loading-value h-4 mx-auto rounded" :class="n % 2 === 0 ? 'w-20' : 'w-16'"></div>
                </div>
            </li>
        </ul>
    </div>

    <!-- Actual Content -->
    <div v-else-if="recentlyViewed?.length">
        <h5
            class="mt-6 mb-4 font-medium type-tertiary text-sm"
            :class="noPadding ? '' : 'px-8'"
        >
            {{ $t("Recently viewed") }}
        </h5>
        <ul
            class="pb-8 w-full overflow-x-auto flex gap-2 first-of-type:-pl-2"
            :class="noPadding ? '' : 'px-8'"
        >
            <li class="shrink-0 w-[167px]" v-for="product in recentlyViewed" :key="product.slug">
                <Link
                    class="bg-v2-gray-130 hover:bg-v2-gray-120 active:bg-gray-tier-6 flex flex-col p-4 rounded h-full group font-medium dark:bg-v2-gray-50 dark:hover:bg-v2-gray-60"
                    :href="route('web.catalog.products.show', product.slug)"
                >
                    <div v-if="_.get(product,'display_thumbnails.0',false)">
                        <img
                            class="h-20 mx-auto"
                            :src="'https://assets.seclock.com/image/private/t_thumb/' + product.display_thumbnails[0]"
                            alt=""
                            loading="lazy"
                        />
                    </div>
                    <span v-else class="flex justify-center flex-col h-20">
                        <BaseSvg name="icon-product-empty" class="block p-4 h-24 w-24 mx-auto fill-gray-tier-7" aria-hidden="true"/>
                    </span>

                    <h5 class="grow whitespace-nowrap truncate text-sm text-center pt-1">
                        {{ product.display_sku }}
                    </h5>
                </Link>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import { Link } from '@inertiajs/vue3';
import { BaseSvg } from "@/Components";
import _ from "lodash";

const route = inject("route");

const props = defineProps({
    recentlyViewed: {
        type: Array,
        default: () => []
    },
    isLoading: {
        type: Boolean,
        default: false
    },
    noPadding: {
        type: Boolean,
        default: false
    }
});
</script>
